export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 品牌用户
    getBrandUserList: function getBrandUserList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand/get",
        method: "get",
        params: data
      });
    },
    // 品牌充值
    brandTopUp: function brandTopUp() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand_account/charge",
        method: "post",
        data: data
      });
    },
    // 更新用户信息
    updateBrandUserInfo: function updateBrandUserInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand_account/updateUserInfo",
        method: "post",
        data: data
      });
    },
    // 品牌认证审核
    brandAuth: function brandAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand/auth",
        method: "post",
        data: data
      });
    },
    // 品牌退款
    brandAccountRefund: function brandAccountRefund() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand_account/refund",
        method: "post",
        data: data
      });
    },
    // 品牌公寓
    getBrandHouseList: function getBrandHouseList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand/houseList",
        method: "get",
        params: data
      });
    },
    // 账户详情
    getBrandAccountDetail: function getBrandAccountDetail() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand_account/statistics",
        method: "get",
        params: data
      });
    },
    // 结算记录
    getBrandSettlementList: function getBrandSettlementList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand_account/getBill",
        method: "get",
        params: data
      });
    },
    // 资金记录
    getBrandMoneyList: function getBrandMoneyList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand_account/chargeRecord",
        method: "get",
        params: data
      });
    },
    // 收入统计
    getBrandIncomeList: function getBrandIncomeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand_account/all",
        method: "get",
        params: data
      });
    },
    // 是否将自动退款
    isAutoRefund: function isAutoRefund() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand_account/isAutoRefund",
        method: "get",
        params: data
      });
    },
    // 设置支付状态
    setBrandAuth: function setBrandAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/brand/auth/set",
        method: "post",
        data: data
      });
    }
  };
});